import { render, staticRenderFns } from "./RateDeck.vue?vue&type=template&id=bc0bc746&"
import script from "./RateDeck.vue?vue&type=script&lang=js&"
export * from "./RateDeck.vue?vue&type=script&lang=js&"
import style0 from "./RateDeck.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RateDeck.vue"
export default component.exports